import React, { useState, useEffect } from "react";

/**
 *
 * @param ref {object} React.createRef 產生的物件
 * @returns {{width: number, height: number}}
 */
const useRefDimensions = (ref) => {
  const [dimensions, setDimensions] = useState({ width: 1, height: 2 });

  useEffect(() => {
    if (ref.current) {
      const { current } = ref;
      const boundingRect = current.getBoundingClientRect();
      const { width, height } = boundingRect;
      if (
        Math.round(width) !== dimensions.width ||
        Math.round(height) !== dimensions.height
      ) {
        setDimensions({ width: Math.round(width), height: Math.round(height) });
      }
    }
  }, [ref]);

  return dimensions;
};

export default useRefDimensions;
